import { NumericInput as PcuiNumericInput } from '@playcanvas/pcui';

import { attachNumericInputScrubFallback } from '../numeric-input-scrub-fallback';

type NumericInputArgs = ConstructorParameters<typeof PcuiNumericInput>[0];

export class NumericInput extends PcuiNumericInput {
    constructor(args: NumericInputArgs = {}) {
        super(args);
        attachNumericInputScrubFallback(this);
    }
}
